(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './androidx-compose-runtime-runtime.js', './androidx-collection-collection.js', './androidx-savedstate-savedstate-compose.js', './androidx-lifecycle-lifecycle-runtime.js', './androidx-savedstate-savedstate.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./androidx-compose-runtime-runtime.js'), require('./androidx-collection-collection.js'), require('./androidx-savedstate-savedstate-compose.js'), require('./androidx-lifecycle-lifecycle-runtime.js'), require('./androidx-savedstate-savedstate.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'androidx-compose-runtime-runtime-saveable'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'androidx-compose-runtime-runtime-saveable'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'androidx-compose-runtime-runtime-saveable'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'androidx-compose-runtime-runtime-saveable'.");
    }
    if (typeof globalThis['androidx-collection-collection'] === 'undefined') {
      throw new Error("Error loading module 'androidx-compose-runtime-runtime-saveable'. Its dependency 'androidx-collection-collection' was not found. Please, check whether 'androidx-collection-collection' is loaded prior to 'androidx-compose-runtime-runtime-saveable'.");
    }
    if (typeof globalThis['androidx-savedstate-savedstate-compose'] === 'undefined') {
      throw new Error("Error loading module 'androidx-compose-runtime-runtime-saveable'. Its dependency 'androidx-savedstate-savedstate-compose' was not found. Please, check whether 'androidx-savedstate-savedstate-compose' is loaded prior to 'androidx-compose-runtime-runtime-saveable'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-runtime'] === 'undefined') {
      throw new Error("Error loading module 'androidx-compose-runtime-runtime-saveable'. Its dependency 'androidx-lifecycle-lifecycle-runtime' was not found. Please, check whether 'androidx-lifecycle-lifecycle-runtime' is loaded prior to 'androidx-compose-runtime-runtime-saveable'.");
    }
    if (typeof globalThis['androidx-savedstate-savedstate'] === 'undefined') {
      throw new Error("Error loading module 'androidx-compose-runtime-runtime-saveable'. Its dependency 'androidx-savedstate-savedstate' was not found. Please, check whether 'androidx-savedstate-savedstate' is loaded prior to 'androidx-compose-runtime-runtime-saveable'.");
    }
    globalThis['androidx-compose-runtime-runtime-saveable'] = factory(typeof globalThis['androidx-compose-runtime-runtime-saveable'] === 'undefined' ? {} : globalThis['androidx-compose-runtime-runtime-saveable'], globalThis['kotlin-kotlin-stdlib'], globalThis['androidx-compose-runtime-runtime'], globalThis['androidx-collection-collection'], globalThis['androidx-savedstate-savedstate-compose'], globalThis['androidx-lifecycle-lifecycle-runtime'], globalThis['androidx-savedstate-savedstate']);
  }
}(function (_, kotlin_kotlin, kotlin_androidx_compose_runtime_runtime, kotlin_androidx_collection_collection, kotlin_androidx_savedstate_savedstate_compose, kotlin_androidx_lifecycle_lifecycle_runtime, kotlin_androidx_savedstate_savedstate) {
  'use strict';
  //region block: imports
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.b4;
  var get_currentCompositeKeyHashCode = kotlin_androidx_compose_runtime_runtime.$_$.l1;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var toString_0 = kotlin_kotlin.$_$.dm;
  var isInterface = kotlin_kotlin.$_$.rg;
  var Companion_getInstance = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var SideEffect = kotlin_androidx_compose_runtime_runtime.$_$.d1;
  var toString_1 = kotlin_kotlin.$_$.hp;
  var protoOf = kotlin_kotlin.$_$.eh;
  var contentEquals = kotlin_kotlin.$_$.f8;
  var RememberObserver = kotlin_androidx_compose_runtime_runtime.$_$.a1;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var neverEqualPolicy = kotlin_androidx_compose_runtime_runtime.$_$.c2;
  var structuralEqualityPolicy = kotlin_androidx_compose_runtime_runtime.$_$.m2;
  var referentialEqualityPolicy = kotlin_androidx_compose_runtime_runtime.$_$.e2;
  var SnapshotMutableState = kotlin_androidx_compose_runtime_runtime.$_$.d;
  var SnapshotMutationPolicy = kotlin_androidx_compose_runtime_runtime.$_$.e1;
  var mutableStateOf = kotlin_androidx_compose_runtime_runtime.$_$.b2;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var MutableState = kotlin_androidx_compose_runtime_runtime.$_$.v;
  var invert = kotlin_kotlin.$_$.qe;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var Long = kotlin_kotlin.$_$.kn;
  var compare = kotlin_kotlin.$_$.je;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var updateChangedFlags = kotlin_androidx_compose_runtime_runtime.$_$.q2;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var mutableScatterMapOf = kotlin_androidx_collection_collection.$_$.j1;
  var get_LocalSavedStateRegistryOwner = kotlin_androidx_savedstate_savedstate_compose.$_$.a;
  var androidx_compose_runtime_ProvidedValue$stableprop_getter = kotlin_androidx_compose_runtime_runtime.$_$.f1;
  var CompositionLocalProvider = kotlin_androidx_compose_runtime_runtime.$_$.k;
  var DisposableEffect = kotlin_androidx_compose_runtime_runtime.$_$.q;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.a4;
  var emptyMap = kotlin_kotlin.$_$.d9;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.c4;
  var ArrayList_init_$Create$_1 = kotlin_kotlin.$_$.z3;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var arrayListOf = kotlin_kotlin.$_$.r7;
  var MutableScatterMap = kotlin_androidx_collection_collection.$_$.n;
  var charSequenceGet = kotlin_kotlin.$_$.kf;
  var isWhitespace = kotlin_kotlin.$_$.jk;
  var staticCompositionLocalOf = kotlin_androidx_compose_runtime_runtime.$_$.l2;
  var Companion_instance = kotlin_androidx_lifecycle_lifecycle_runtime.$_$.a;
  var Companion_instance_0 = kotlin_androidx_savedstate_savedstate.$_$.l;
  var toMutableMap = kotlin_kotlin.$_$.rc;
  var SavedState = kotlin_androidx_savedstate_savedstate.$_$.b;
  var _SavedStateWriter___init__impl__99cr38 = kotlin_androidx_savedstate_savedstate.$_$.h;
  var _SavedStateReader___init__impl__k2stzo = kotlin_androidx_savedstate_savedstate.$_$.c;
  var SavedStateReader__isEmpty_impl_ep4h1z = kotlin_androidx_savedstate_savedstate.$_$.f;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(SaveableHolder, 'SaveableHolder', VOID, VOID, [RememberObserver]);
  initMetadataForCompanion(Companion);
  initMetadataForClass(SaveableStateHolderImpl$SaveableStateProvider$$inlined$ReusableContent$1$1);
  initMetadataForClass(SaveableStateHolderImpl, 'SaveableStateHolderImpl', SaveableStateHolderImpl);
  initMetadataForInterface(SaveableStateRegistry, 'SaveableStateRegistry');
  initMetadataForClass(SaveableStateRegistryImpl$registerProvider$1);
  initMetadataForClass(SaveableStateRegistryImpl, 'SaveableStateRegistryImpl', VOID, VOID, [SaveableStateRegistry]);
  initMetadataForClass(SaveableStateRegistryWrapper, 'SaveableStateRegistryWrapper', VOID, VOID, [SaveableStateRegistry]);
  initMetadataForInterface(Saver, 'Saver');
  initMetadataForClass(Saver$1, VOID, VOID, VOID, [Saver]);
  //endregion
  function listSaver(save, restore) {
    var tmp = listSaver$lambda(save);
    return Saver_0(tmp, typeof restore === 'function' ? restore : THROW_CCE());
  }
  function listSaver$lambda($save) {
    return function ($this$Saver, it) {
      var list = $save($this$Saver, it);
      var inductionVariable = 0;
      var last = list.n1() - 1 | 0;
      var tmp;
      if (inductionVariable <= last) {
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = list.l1(index);
          if (!(item == null)) {
            // Inline function 'kotlin.require' call
            if (!$this$Saver.z7n(item)) {
              var message = 'item at index ' + index + " can't be saved: " + toString(item);
              throw IllegalArgumentException_init_$Create$(toString(message));
            }
          }
        }
         while (inductionVariable <= last);
        tmp = Unit_instance;
      }
      var tmp_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!list.r()) {
        tmp_0 = ArrayList_init_$Create$(list);
      } else {
        tmp_0 = null;
      }
      return tmp_0;
    };
  }
  var MaxSupportedRadix;
  function rememberSaveable(inputs, saver, init, $composer, $changed) {
    var $composer_0 = $composer;
    return rememberSaveable_0(inputs.slice(), saver, null, init, $composer_0, 384 | 112 & $changed | 7168 & $changed << 3, 0);
  }
  function rememberSaveable_0(inputs, saver, key, init, $composer, $changed, $default) {
    var saver_0 = {_v: saver};
    var key_0 = key;
    var $composer_0 = $composer;
    if (!(($default & 2) === 0)) {
      saver_0._v = autoSaver();
    }
    if (!(($default & 4) === 0))
      key_0 = null;
    var compositeKey = get_currentCompositeKeyHashCode($composer_0, 0);
    var tmp;
    // Inline function 'kotlin.text.isNullOrEmpty' call
    var this_0 = key_0;
    if (!(this_0 == null || charSequenceLength(this_0) === 0)) {
      tmp = key_0;
    } else {
      // Inline function 'androidx.compose.runtime.toString' call
      var radix = MaxSupportedRadix;
      tmp = toString_0(compositeKey, radix);
    }
    var finalKey = tmp;
    var tmp_0 = saver_0._v;
    if (!isInterface(tmp_0, Saver))
      THROW_CCE();
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_1 = get_LocalSaveableStateRegistry();
    var $composer_1 = $composer_0;
    var registry = $composer_1.u31(this_1);
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp_1;
    if (false || it === Companion_getInstance().f30_1) {
      var tmp1_safe_receiver = registry == null ? null : registry.a7o(finalKey);
      var tmp_2;
      if (tmp1_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_2 = saver_0._v.b7o(tmp1_safe_receiver);
      }
      var restored = tmp_2;
      var finalValue = restored == null ? init() : restored;
      var value = new SaveableHolder(saver_0._v, registry, finalKey, finalValue, inputs);
      $composer_0.j31(value);
      tmp_1 = value;
    } else {
      tmp_1 = it;
    }
    var holder = tmp_1;
    var tmp0_elvis_lhs = holder.j7o(inputs);
    var value_0 = tmp0_elvis_lhs == null ? init() : tmp0_elvis_lhs;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!(!!(!!(!!($composer_0.q31(holder) | (($changed & 112 ^ 48) > 32 && $composer_0.q31(saver_0._v) || ($changed & 48) === 32)) | $composer_0.q31(registry)) | $composer_0.k31(finalKey)) | $composer_0.q31(value_0)) | $composer_0.q31(inputs));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_3;
    if (invalid || it_0 === Companion_getInstance().f30_1) {
      var value_1 = rememberSaveable$lambda(holder, saver_0, registry, finalKey, value_0, inputs);
      $composer_0.j31(value_1);
      tmp_3 = value_1;
    } else {
      tmp_3 = it_0;
    }
    var tmp$ret$9 = tmp_3;
    SideEffect(tmp$ret$9, $composer_0, 0);
    return value_0;
  }
  function register($this) {
    var registry = $this.d7o_1;
    // Inline function 'kotlin.require' call
    if (!($this.h7o_1 == null)) {
      var message = 'entry(' + toString_1($this.h7o_1) + ') is not null';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    if (!(registry == null)) {
      requireCanBeSaved(registry, $this.i7o_1());
      $this.h7o_1 = registry.k7o($this.e7o_1, $this.i7o_1);
    }
  }
  function SaveableHolder$valueProvider$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.with' call
      var $this$with = this$0.c7o_1;
      var tmp0 = this$0.f7o_1;
      var tmp$ret$2;
      $l$block: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0 == null) {
          var message = 'Value should be initialized';
          throw IllegalArgumentException_init_$Create$(toString(message));
        } else {
          tmp$ret$2 = tmp0;
          break $l$block;
        }
      }
      return $this$with.l7o(this$0, tmp$ret$2);
    };
  }
  function SaveableHolder(saver, registry, key, value, inputs) {
    this.c7o_1 = saver;
    this.d7o_1 = registry;
    this.e7o_1 = key;
    this.f7o_1 = value;
    this.g7o_1 = inputs;
    this.h7o_1 = null;
    var tmp = this;
    tmp.i7o_1 = SaveableHolder$valueProvider$lambda(this);
  }
  protoOf(SaveableHolder).m7o = function (saver, registry, key, value, inputs) {
    var entryIsOutdated = false;
    if (!(this.d7o_1 === registry)) {
      this.d7o_1 = registry;
      entryIsOutdated = true;
    }
    if (!(this.e7o_1 === key)) {
      this.e7o_1 = key;
      entryIsOutdated = true;
    }
    this.c7o_1 = saver;
    this.f7o_1 = value;
    this.g7o_1 = inputs;
    if (!(this.h7o_1 == null) && entryIsOutdated) {
      var tmp0_safe_receiver = this.h7o_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.n7o();
      }
      this.h7o_1 = null;
      register(this);
    }
  };
  protoOf(SaveableHolder).z7n = function (value) {
    var registry = this.d7o_1;
    return registry == null || registry.z7n(value);
  };
  protoOf(SaveableHolder).g3f = function () {
    register(this);
  };
  protoOf(SaveableHolder).h3f = function () {
    var tmp0_safe_receiver = this.h7o_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.n7o();
    }
  };
  protoOf(SaveableHolder).i3f = function () {
    var tmp0_safe_receiver = this.h7o_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.n7o();
    }
  };
  protoOf(SaveableHolder).j7o = function (inputs) {
    var tmp;
    if (contentEquals(inputs, this.g7o_1)) {
      tmp = this.f7o_1;
    } else {
      tmp = null;
    }
    return tmp;
  };
  function requireCanBeSaved(_this__u8e3s4, value) {
    if (!(value == null) && !_this__u8e3s4.z7n(value)) {
      var tmp;
      if (isInterface(value, SnapshotMutableState)) {
        var tmp_0;
        if (!(value.h3d() === neverEqualPolicy()) && !(value.h3d() === structuralEqualityPolicy()) && !(value.h3d() === referentialEqualityPolicy())) {
          tmp_0 = 'If you use a custom SnapshotMutationPolicy for your MutableState you have to write a custom Saver';
        } else {
          tmp_0 = 'MutableState containing ' + toString_1(value.u1()) + ' cannot be saved using the current ' + 'SaveableStateRegistry. The default implementation only supports types which can be stored inside the Bundle. Please consider implementing a custom Saver for this class and pass it as a stateSaver parameter to rememberSaveable().';
        }
        tmp = tmp_0;
      } else {
        tmp = generateCannotBeSavedErrorMessage(value);
      }
      throw IllegalArgumentException_init_$Create$(tmp);
    }
  }
  function generateCannotBeSavedErrorMessage(value) {
    return toString(value) + ' cannot be saved using the current SaveableStateRegistry. The default ' + 'implementation only supports types which can be stored inside the Bundle. Please consider implementing a custom Saver for this class and pass it to rememberSaveable().';
  }
  function rememberSaveable_1(inputs, init, $composer, $changed) {
    var $composer_0 = $composer;
    return rememberSaveable_0(inputs.slice(), autoSaver(), null, init, $composer_0, 384 | 7168 & $changed << 6, 0);
  }
  function rememberSaveable_2(inputs, stateSaver, init, $composer, $changed) {
    var $composer_0 = $composer;
    return rememberSaveable_0(inputs.slice(), mutableStateSaver(stateSaver), null, init, $composer_0, 384 | 7168 & $changed << 3, 0);
  }
  function mutableStateSaver(inner) {
    // Inline function 'kotlin.with' call
    var $this$with = isInterface(inner, Saver) ? inner : THROW_CCE();
    var tmp = mutableStateSaver$lambda($this$with);
    return Saver_0(tmp, mutableStateSaver$lambda_0($this$with));
  }
  function rememberSaveable$lambda($holder, $saver, $registry, $finalKey, $value, $inputs) {
    return function () {
      $holder.m7o($saver._v, $registry, $finalKey, $value, $inputs);
      return Unit_instance;
    };
  }
  function mutableStateSaver$lambda($$this$with) {
    return function ($this$Saver, state) {
      // Inline function 'kotlin.require' call
      if (!isInterface(state, SnapshotMutableState)) {
        var message = 'If you use a custom MutableState implementation you have to write a custom Saver and pass it as a saver param to rememberSaveable()';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      var saved = $$this$with.l7o($this$Saver, state.u1());
      var tmp;
      if (!(saved == null)) {
        var tmp_0 = state.h3d();
        tmp = mutableStateOf(saved, isInterface(tmp_0, SnapshotMutationPolicy) ? tmp_0 : THROW_CCE());
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function mutableStateSaver$lambda_0($$this$with) {
    return function (it) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!isInterface(it, SnapshotMutableState)) {
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      var tmp = !(it.u1() == null) ? $$this$with.b7o(ensureNotNull(it.u1())) : null;
      var tmp_0 = it.h3d();
      var tmp_1 = mutableStateOf(tmp, isInterface(tmp_0, SnapshotMutationPolicy) ? tmp_0 : THROW_CCE());
      return isInterface(tmp_1, MutableState) ? tmp_1 : THROW_CCE();
    };
  }
  function rememberSaveableStateHolder($composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.m30(1967007413);
    var tmp = Companion_getInstance_0().o7o_1;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp_0;
    if (false || it === Companion_getInstance().f30_1) {
      var value = rememberSaveableStateHolder$lambda;
      $composer_0.j31(value);
      tmp_0 = value;
    } else {
      tmp_0 = it;
    }
    var tmp$ret$0 = tmp_0;
    // Inline function 'kotlin.apply' call
    var this_0 = rememberSaveable([], tmp, tmp$ret$0, $composer_0, 384);
    var tmp_1 = this_0;
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_1 = get_LocalSaveableStateRegistry();
    var $composer_1 = $composer_0;
    tmp_1.r7o_1 = $composer_1.u31(this_1);
    $composer_0.n30();
    return this_0;
  }
  function SaveableStateHolderImpl$Companion$Saver$lambda($this$Saver, it) {
    return saveAll(it);
  }
  function SaveableStateHolderImpl$Companion$Saver$lambda_0(it) {
    return new SaveableStateHolderImpl(it);
  }
  function saveAll($this) {
    var map = $this.p7o_1;
    // Inline function 'androidx.collection.ScatterMap.forEach' call
    var this_0 = $this.q7o_1;
    var k = this_0.x12_1;
    var v = this_0.y12_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_0.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var tmp0 = k[index];
                  var registry = v[index];
                  saveTo($this, registry, map, tmp0);
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    // Inline function 'kotlin.collections.ifEmpty' call
    var tmp;
    if (map.r()) {
      tmp = null;
    } else {
      tmp = map;
    }
    return tmp;
  }
  function saveTo($this, $receiver, map, key) {
    var savedData = $receiver.t7o();
    if (savedData.r()) {
      // Inline function 'kotlin.collections.minusAssign' call
      map.a3(key);
    } else {
      // Inline function 'kotlin.collections.set' call
      map.z2(key, savedData);
    }
  }
  function Companion() {
    Companion_instance_1 = this;
    var tmp = this;
    var tmp_0 = SaveableStateHolderImpl$Companion$Saver$lambda;
    tmp.o7o_1 = Saver_0(tmp_0, SaveableStateHolderImpl$Companion$Saver$lambda_0);
  }
  var Companion_instance_1;
  function Companion_getInstance_0() {
    if (Companion_instance_1 == null)
      new Companion();
    return Companion_instance_1;
  }
  function SaveableStateHolderImpl$canBeSaved$lambda(this$0) {
    return function (it) {
      var tmp0_safe_receiver = this$0.r7o_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z7n(it);
      return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
    };
  }
  function SaveableStateHolderImpl$SaveableStateProvider$$inlined$ReusableContent$1$1(this$0, $key, $registry) {
    this.u7o_1 = this$0;
    this.v7o_1 = $key;
    this.w7o_1 = $registry;
  }
  protoOf(SaveableStateHolderImpl$SaveableStateProvider$$inlined$ReusableContent$1$1).s1d = function () {
    if (this.u7o_1.q7o_1.a3(this.v7o_1) === this.w7o_1) {
      saveTo(this.u7o_1, this.w7o_1, this.u7o_1.p7o_1, this.v7o_1);
    }
  };
  function SaveableStateHolderImpl$SaveableStateProvider$lambda(this$0, $key, $registry) {
    return function ($this$DisposableEffect) {
      // Inline function 'kotlin.require' call
      if (!!this$0.q7o_1.d6($key)) {
        var message = 'Key ' + toString($key) + ' was used multiple times ';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      var tmp0 = this$0.p7o_1;
      // Inline function 'kotlin.collections.minusAssign' call
      var key = $key;
      tmp0.a3(key);
      this$0.q7o_1.h13($key, $registry);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new SaveableStateHolderImpl$SaveableStateProvider$$inlined$ReusableContent$1$1(this$0, $key, $registry);
    };
  }
  function SaveableStateHolderImpl$SaveableStateProvider$lambda_0($tmp0_rcvr, $key, $content, $$changed) {
    return function ($composer, $force) {
      $tmp0_rcvr.x7o($key, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function SaveableStateHolderImpl(savedStates) {
    Companion_getInstance_0();
    var tmp;
    if (savedStates === VOID) {
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp = LinkedHashMap_init_$Create$();
    } else {
      tmp = savedStates;
    }
    savedStates = tmp;
    this.p7o_1 = savedStates;
    this.q7o_1 = mutableScatterMapOf();
    this.r7o_1 = null;
    var tmp_0 = this;
    tmp_0.s7o_1 = SaveableStateHolderImpl$canBeSaved$lambda(this);
  }
  protoOf(SaveableStateHolderImpl).x7o = function (key, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(533563200);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(key) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(this) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      // Inline function 'androidx.compose.runtime.ReusableContent' call
      var $composer_1 = $composer_0;
      $composer_1.f31(207, key);
      var $composer_2 = $composer_1;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_2.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        // Inline function 'kotlin.require' call
        if (!this.s7o_1(key)) {
          var message = 'Type of the key ' + toString(key) + ' is not supported. On Android you can only use types ' + 'which can be stored inside the Bundle.';
          throw IllegalArgumentException_init_$Create$(toString(message));
        }
        var value = new SaveableStateRegistryWrapper(SaveableStateRegistry_0(this.p7o_1.w2(key), this.s7o_1));
        $composer_2.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var registry = tmp;
      CompositionLocalProvider([get_LocalSaveableStateRegistry().h3c(registry), get_LocalSavedStateRegistryOwner().h3c(registry)], content, $composer_2, androidx_compose_runtime_ProvidedValue$stableprop_getter() | 112 & $dirty);
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!($composer_0.q31(this) | $composer_0.q31(key)) | $composer_0.q31(registry));
      // Inline function 'kotlin.let' call
      var it_0 = $composer_2.i31();
      var tmp_0;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = SaveableStateHolderImpl$SaveableStateProvider$lambda(this, key, registry);
        $composer_2.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp$ret$8 = tmp_0;
      DisposableEffect(Unit_instance, tmp$ret$8, $composer_2, 6);
      $composer_1.g31();
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(SaveableStateHolderImpl$SaveableStateProvider$lambda_0(this, key, content, $changed));
    }
  };
  protoOf(SaveableStateHolderImpl).y7o = function (key) {
    if (this.q7o_1.a3(key) == null) {
      // Inline function 'kotlin.collections.minusAssign' call
      this.p7o_1.a3(key);
    }
  };
  function rememberSaveableStateHolder$lambda() {
    return new SaveableStateHolderImpl();
  }
  function get_LocalSaveableStateRegistry() {
    _init_properties_SaveableStateRegistry_kt__lr5zhh();
    return LocalSaveableStateRegistry;
  }
  var LocalSaveableStateRegistry;
  function SaveableStateRegistry() {
  }
  function SaveableStateRegistry_0(restoredValues, canBeSaved) {
    _init_properties_SaveableStateRegistry_kt__lr5zhh();
    return new SaveableStateRegistryImpl(restoredValues, canBeSaved);
  }
  function SaveableStateRegistryImpl$registerProvider$1($valueProviders, $key, $valueProvider) {
    this.z7o_1 = $valueProviders;
    this.a7p_1 = $key;
    this.b7p_1 = $valueProvider;
  }
  protoOf(SaveableStateRegistryImpl$registerProvider$1).n7o = function () {
    var list = this.z7o_1.a3(this.a7p_1);
    if (list == null)
      null;
    else
      list.d3(this.b7p_1);
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    if (!(list == null || list.r())) {
      this.z7o_1.h13(this.a7p_1, list);
    }
  };
  function SaveableStateRegistryImpl(restored, canBeSaved) {
    this.c7p_1 = canBeSaved;
    var tmp = this;
    var tmp_0;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    if (!(restored == null || restored.r())) {
      tmp_0 = toMutableScatterMap(restored);
    } else {
      tmp_0 = null;
    }
    tmp.d7p_1 = tmp_0;
    this.e7p_1 = null;
  }
  protoOf(SaveableStateRegistryImpl).z7n = function (value) {
    return this.c7p_1(value);
  };
  protoOf(SaveableStateRegistryImpl).a7o = function (key) {
    var tmp0_safe_receiver = this.d7p_1;
    var list = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a3(key);
    var tmp;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    if (!(list == null || list.r())) {
      if (list.n1() > 1) {
        var tmp1_safe_receiver = this.d7p_1;
        if (tmp1_safe_receiver == null)
          null;
        else
          tmp1_safe_receiver.z2(key, list.t2(1, list.n1()));
      }
      tmp = list.l1(0);
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(SaveableStateRegistryImpl).k7o = function (key, valueProvider) {
    // Inline function 'kotlin.require' call
    if (!!fastIsBlank(key)) {
      var message = 'Registered key is empty or blank';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var tmp0_elvis_lhs = this.e7p_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = mutableScatterMapOf();
      this.e7p_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var valueProviders = tmp;
    // Inline function 'androidx.collection.MutableScatterMap.getOrPut' call
    var tmp0_elvis_lhs_0 = valueProviders.w2(key);
    var tmp_0;
    if (tmp0_elvis_lhs_0 == null) {
      // Inline function 'kotlin.collections.mutableListOf' call
      // Inline function 'kotlin.also' call
      var this_1 = ArrayList_init_$Create$_0();
      valueProviders.h13(key, this_1);
      tmp_0 = this_1;
    } else {
      tmp_0 = tmp0_elvis_lhs_0;
    }
    tmp_0.j1(valueProvider);
    return new SaveableStateRegistryImpl$registerProvider$1(valueProviders, key, valueProvider);
  };
  protoOf(SaveableStateRegistryImpl).t7o = function () {
    if (this.d7p_1 == null && this.e7p_1 == null) {
      return emptyMap();
    }
    var tmp0_safe_receiver = this.d7p_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n1();
    var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp2_safe_receiver = this.e7p_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.n1();
    var expectedMapSize = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    // Inline function 'kotlin.apply' call
    var this_0 = HashMap_init_$Create$(expectedMapSize);
    var tmp0_safe_receiver_0 = this.d7p_1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'androidx.collection.ScatterMap.forEach' call
      var k = tmp0_safe_receiver_0.x12_1;
      var v = tmp0_safe_receiver_0.y12_1;
      $l$block: {
        // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
        var m = tmp0_safe_receiver_0.w12_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var tmp0 = k[index];
                    // Inline function 'kotlin.collections.set' call
                    var value_0 = v[index];
                    this_0.z2(tmp0, value_0);
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
    }
    var map = this_0;
    var tmp4_safe_receiver = this.e7p_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.collection.ScatterMap.forEach' call
      var k_0 = tmp4_safe_receiver.x12_1;
      var v_0 = tmp4_safe_receiver.y12_1;
      $l$block_0: {
        // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
        var m_0 = tmp4_safe_receiver.w12_1;
        var lastIndex_0 = m_0.length - 2 | 0;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= lastIndex_0)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var slot_0 = m_0[i_0];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_2 = slot_0;
            var tmp$ret$11 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$11, new Long(-2139062144, -2139062144))) {
              var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < bitCount_0)
                do {
                  var j_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value_1 = bitwiseAnd(slot_0, new Long(255, 0));
                  if (compare(value_1, new Long(128, 0)) < 0) {
                    var index_0 = (i_0 << 3) + j_0 | 0;
                    var tmp0_0 = k_0[index_0];
                    var list = v_0[index_0];
                    if (list.n1() === 1) {
                      var value_2 = list.l1(0)();
                      if (!(value_2 == null)) {
                        // Inline function 'kotlin.check' call
                        if (!this.z7n(value_2)) {
                          var message = generateCannotBeSavedErrorMessage(value_2);
                          throw IllegalStateException_init_$Create$(toString(message));
                        }
                        // Inline function 'kotlin.collections.set' call
                        var value_3 = arrayListOf([value_2]);
                        map.z2(tmp0_0, value_3);
                      }
                    } else {
                      // Inline function 'kotlin.collections.List' call
                      // Inline function 'kotlin.collections.MutableList' call
                      var size = list.n1();
                      var list_0 = ArrayList_init_$Create$_1(size);
                      // Inline function 'kotlin.repeat' call
                      var inductionVariable_3 = 0;
                      if (inductionVariable_3 < size)
                        do {
                          var index_1 = inductionVariable_3;
                          inductionVariable_3 = inductionVariable_3 + 1 | 0;
                          var value_4 = list.l1(index_1)();
                          if (!(value_4 == null)) {
                            // Inline function 'kotlin.check' call
                            if (!this.z7n(value_4)) {
                              var message_0 = generateCannotBeSavedErrorMessage(value_4);
                              throw IllegalStateException_init_$Create$(toString(message_0));
                            }
                          }
                          list_0.j1(value_4);
                        }
                         while (inductionVariable_3 < size);
                      // Inline function 'kotlin.collections.set' call
                      map.z2(tmp0_0, list_0);
                    }
                  }
                  slot_0 = shiftRight(slot_0, 8);
                }
                 while (inductionVariable_2 < bitCount_0);
              if (!(bitCount_0 === 8)) {
                break $l$block_0;
              }
            }
          }
           while (!(i_0 === lastIndex_0));
      }
    }
    return map;
  };
  function toMutableScatterMap(_this__u8e3s4) {
    _init_properties_SaveableStateRegistry_kt__lr5zhh();
    // Inline function 'kotlin.also' call
    var this_0 = new MutableScatterMap(_this__u8e3s4.n1());
    // Inline function 'androidx.collection.MutableScatterMap.plusAssign' call
    this_0.j13(_this__u8e3s4);
    return this_0;
  }
  function fastIsBlank(_this__u8e3s4) {
    _init_properties_SaveableStateRegistry_kt__lr5zhh();
    var blank = true;
    var inductionVariable = 0;
    var last = charSequenceLength(_this__u8e3s4);
    if (inductionVariable < last)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!isWhitespace(charSequenceGet(_this__u8e3s4, i))) {
          blank = false;
          break $l$loop;
        }
      }
       while (inductionVariable < last);
    return blank;
  }
  function LocalSaveableStateRegistry$lambda() {
    _init_properties_SaveableStateRegistry_kt__lr5zhh();
    return null;
  }
  var properties_initialized_SaveableStateRegistry_kt_4lrdzt;
  function _init_properties_SaveableStateRegistry_kt__lr5zhh() {
    if (!properties_initialized_SaveableStateRegistry_kt_4lrdzt) {
      properties_initialized_SaveableStateRegistry_kt_4lrdzt = true;
      LocalSaveableStateRegistry = staticCompositionLocalOf(LocalSaveableStateRegistry$lambda);
    }
  }
  var androidx_compose_runtime_saveable_SaveableStateRegistryWrapper$stable;
  function getOrInitLifecycle($this) {
    var tmp0_elvis_lhs = $this.g7p_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = Companion_instance.w7n($this);
      $this.g7p_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_controller__bh9bov($this) {
    return getOrInitController($this, null);
  }
  function getOrInitController($this, savedState) {
    var tmp0_elvis_lhs = $this.h7p_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = Companion_instance_0.c7n($this);
      $this.h7p_1 = this_0;
      this_0.f7n(savedState);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function SaveableStateRegistryWrapper$lambda(this$0) {
    return function () {
      var controller = this$0.h7p_1;
      var tmp;
      if (!(controller == null)) {
        // Inline function 'androidx.savedstate.savedState' call
        var initialState = emptyMap();
        var copiedState = toMutableMap(initialState);
        // Inline function 'kotlin.apply' call
        var this_0 = new SavedState(copiedState);
        // Inline function 'androidx.savedstate.write' call
        _SavedStateWriter___init__impl__99cr38(this_0);
        var result = this_0;
        controller.g7n(result);
        var tmp_0;
        // Inline function 'androidx.savedstate.read' call
        var $this$read = _SavedStateReader___init__impl__k2stzo(result);
        if (SavedStateReader__isEmpty_impl_ep4h1z($this$read)) {
          tmp_0 = null;
        } else {
          tmp_0 = result;
        }
        tmp = tmp_0;
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function SaveableStateRegistryWrapper(base) {
    this.f7p_1 = base;
    this.g7p_1 = null;
    this.h7p_1 = null;
    var tmp = this.a7o('androidx.savedstate.SavedStateRegistry');
    var savedState = tmp instanceof SavedState ? tmp : null;
    if (!(savedState == null)) {
      getOrInitController(this, savedState);
    }
    this.k7o('androidx.savedstate.SavedStateRegistry', SaveableStateRegistryWrapper$lambda(this));
  }
  protoOf(SaveableStateRegistryWrapper).w7m = function () {
    return getOrInitLifecycle(this);
  };
  protoOf(SaveableStateRegistryWrapper).i7p = function () {
    return _get_controller__bh9bov(this).e7n_1;
  };
  protoOf(SaveableStateRegistryWrapper).a7o = function (key) {
    return this.f7p_1.a7o(key);
  };
  protoOf(SaveableStateRegistryWrapper).k7o = function (key, valueProvider) {
    return this.f7p_1.k7o(key, valueProvider);
  };
  protoOf(SaveableStateRegistryWrapper).z7n = function (value) {
    return this.f7p_1.z7n(value);
  };
  protoOf(SaveableStateRegistryWrapper).t7o = function () {
    return this.f7p_1.t7o();
  };
  function get_AutoSaver() {
    _init_properties_Saver_kt__z47nhf();
    return AutoSaver;
  }
  var AutoSaver;
  function Saver() {
  }
  function Saver_0(save, restore) {
    _init_properties_Saver_kt__z47nhf();
    return new Saver$1(save, restore);
  }
  function autoSaver() {
    _init_properties_Saver_kt__z47nhf();
    var tmp = get_AutoSaver();
    return isInterface(tmp, Saver) ? tmp : THROW_CCE();
  }
  function AutoSaver$lambda($this$Saver, it) {
    _init_properties_Saver_kt__z47nhf();
    return it;
  }
  function AutoSaver$lambda_0(it) {
    _init_properties_Saver_kt__z47nhf();
    return it;
  }
  function Saver$1($save, $restore) {
    this.j7p_1 = $save;
    this.k7p_1 = $restore;
  }
  protoOf(Saver$1).l7o = function (_this__u8e3s4, value) {
    return this.j7p_1(_this__u8e3s4, value);
  };
  protoOf(Saver$1).b7o = function (value) {
    return this.k7p_1(value);
  };
  var properties_initialized_Saver_kt_ch40dh;
  function _init_properties_Saver_kt__z47nhf() {
    if (!properties_initialized_Saver_kt_ch40dh) {
      properties_initialized_Saver_kt_ch40dh = true;
      var tmp = AutoSaver$lambda;
      AutoSaver = Saver_0(tmp, AutoSaver$lambda_0);
    }
  }
  //region block: init
  MaxSupportedRadix = 36;
  androidx_compose_runtime_saveable_SaveableStateRegistryWrapper$stable = 8;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = get_LocalSaveableStateRegistry;
  _.$_$.b = SaveableStateRegistry_0;
  _.$_$.c = SaveableStateRegistry;
  _.$_$.d = Saver_0;
  _.$_$.e = Saver;
  _.$_$.f = listSaver;
  _.$_$.g = rememberSaveableStateHolder;
  _.$_$.h = rememberSaveable_2;
  _.$_$.i = rememberSaveable_1;
  _.$_$.j = rememberSaveable;
  //endregion
  return _;
}));

//# sourceMappingURL=androidx-compose-runtime-runtime-saveable.js.map
